import { AppDispatch } from 'store/index';
import { measurementsSlice } from 'store/reducers/measurements';

export const toggleRulerModeAction = () => (dispatch: AppDispatch) => {
  dispatch(measurementsSlice.actions.toggleRulerMode());
};
